var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "studio-page-header",
        class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
      },
      [
        _c("div", { staticClass: "d-flex" }, [
          _c("img", {
            staticClass: "back-to-list-apps",
            attrs: { src: require("@/assets/icon/arrow-left.svg") },
            on: {
              click: function($event) {
                _vm.$router.push("/administrator/layer")
              }
            }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "label-header-form-ui ellipsis" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.layer_detail ? _vm.layer_detail.name : "") +
                "\n      "
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "studio-page-content" }, [
      _c(
        "div",
        [
          _c("j-layer-form", {
            ref: "layerForm",
            attrs: { mode: "update" },
            on: { data: _vm.getData }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-column align-items-end" },
        [
          _c(
            "b-button",
            {
              staticClass: "btn blue m__r--5",
              on: { click: _vm.saveUpdateLayer }
            },
            [_vm._v("\n        Update\n      ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            { staticClass: "btn red", on: { click: _vm.onClickDelete } },
            [_vm._v("\n        Delete\n      ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c329f48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c329f48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layer/jLayerUpdate.vue
// module id = null
// module chunks = 